import React from "react"

function LoadingButton(props) {
  return (
    <button
      type="button"
      className={props.classes ? props.classes : "custom-btn gradiant-btn sm-btn"}
      disabled={false}
    >
      <span className="circle-fade">
      </span>
      <span>Loading...</span>
    </button>
  )
}
export default LoadingButton
